__turbopack_context__.v({
  "--otp": "page-module__t07QGG__--otp",
  "auth-spin": "page-module__t07QGG__auth-spin",
  "authErrorIcon": "page-module__t07QGG__authErrorIcon",
  "authErrorMessage": "page-module__t07QGG__authErrorMessage",
  "authErrorNote": "page-module__t07QGG__authErrorNote",
  "authSignMain": "page-module__t07QGG__authSignMain",
  "bottomText": "page-module__t07QGG__bottomText",
  "box": "page-module__t07QGG__box",
  "changeSecuredDataModal": "page-module__t07QGG__changeSecuredDataModal",
  "coverImage": "page-module__t07QGG__coverImage",
  "coverSection": "page-module__t07QGG__coverSection",
  "description": "page-module__t07QGG__description",
  "error-message": "page-module__t07QGG__error-message",
  "forgotPassword": "page-module__t07QGG__forgotPassword",
  "formSection": "page-module__t07QGG__formSection",
  "headline": "page-module__t07QGG__headline",
  "icon": "page-module__t07QGG__icon",
  "inner": "page-module__t07QGG__inner",
  "input": "page-module__t07QGG__input",
  "intro": "page-module__t07QGG__intro",
  "label": "page-module__t07QGG__label",
  "laptop": "page-module__t07QGG__laptop",
  "loadingSpinner": "page-module__t07QGG__loadingSpinner",
  "loadingStatus": "page-module__t07QGG__loadingStatus",
  "logo": "page-module__t07QGG__logo",
  "minStrength": "page-module__t07QGG__minStrength",
  "orItem": "page-module__t07QGG__orItem",
  "password": "page-module__t07QGG__password",
  "passwordStrengthIndicator": "page-module__t07QGG__passwordStrengthIndicator",
  "passwordVisibilityToggle": "page-module__t07QGG__passwordVisibilityToggle",
  "progress": "page-module__t07QGG__progress",
  "recaptchaField": "page-module__t07QGG__recaptchaField",
  "resend": "page-module__t07QGG__resend",
  "row": "page-module__t07QGG__row",
  "signBox": "page-module__t07QGG__signBox",
  "small": "page-module__t07QGG__small",
  "socialButton": "page-module__t07QGG__socialButton",
  "socialButtonApple": "page-module__t07QGG__socialButtonApple",
  "socialButtonFacebook": "page-module__t07QGG__socialButtonFacebook",
  "socialButtonGoogle": "page-module__t07QGG__socialButtonGoogle",
  "socialButtonInstagram": "page-module__t07QGG__socialButtonInstagram",
  "socialSignin": "page-module__t07QGG__socialSignin",
  "step": "page-module__t07QGG__step",
  "stepDot": "page-module__t07QGG__stepDot",
  "stepLine": "page-module__t07QGG__stepLine",
  "submitButton": "page-module__t07QGG__submitButton",
  "submitLabel": "page-module__t07QGG__submitLabel",
  "switchMode": "page-module__t07QGG__switchMode",
  "termsField": "page-module__t07QGG__termsField",
  "title": "page-module__t07QGG__title",
  "wrapper": "page-module__t07QGG__wrapper",
});
